import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {Estacao} from '../models/estacao.model';
import {Platform} from '@ionic/angular';
import {EstacaoService} from './estacao.service';
import {from, Observable, of} from 'rxjs';
import {FavoritoService} from './favorito.service';
import {catchError, flatMap} from 'rxjs/operators';
import {observe} from '../util/loading';

@Injectable({
  providedIn: 'root'
})
export class PainelResolve implements Resolve<Estacao[]> {

  constructor(
    private router: Router,
    private platform: Platform,
    private estacaoService: EstacaoService,
    private favoritoService: FavoritoService
  ) {
  }

  resolve(activeRoute: ActivatedRouteSnapshot): Observable<Estacao[]> {
    const load = from(this.favoritoService.init()).pipe(
      flatMap(estacoes => {
          if (estacoes.length) {
            const ids = [];
            for (const estacao of estacoes) {
              ids.push(estacao.idEstacao);
            }
            return this.estacaoService.buscarPorIds(ids.join(','));
          }
          return of([]);
        }
      ),
      catchError(() => {
        return from(this.favoritoService.init());
      })
    );
    return observe(load);
  }
}
